const mandatoryFields = ['screen_title', 'data'];

export default mandatoryFields;
